import BaseTimePicker from 'app/components/forms/base_time_picker/base_time_picker'
import { nullValidator, withValidation } from 'app/components/forms/util'

const InputTimeOptional = withValidation(BaseTimePicker, nullValidator)

export default InputTimeOptional
